<template>
    <div id="panel-1" class="panel">
        <div class="panel-hdr">
            <h2>
                Accept <span class="fw-300"><i> Order</i></span>
            </h2>
            <div class="panel-toolbar">
                <a href="javascript:void(0)"
                    class="btn btn-sm btn-success mx-1"
                    data-toggle="tooltip" 
                    data-offset="0,10" 
                    data-original-title="Accept Order"
                    @click="acceptOrder">
                    <i class="fal fa-check"></i>
                    Accept
                </a>
                <a :href="appUrl+'/seller/pending-orders'"
                    class="btn btn-sm btn-danger mx-1"
                    data-toggle="tooltip"
                    data-offset="0,10" 
                    data-original-title="Cancel">
                    <i class="fal fa-times"></i>
                    Cancel
                </a>
            </div>
        </div>
        <div class="panel-container show">
            <div class="panel-content">
                <div class="card-deck my-3">
                    <div class="card">
                        <div class="card-body">
                            <div class="row mb-2">
                                <div class="col-4">
                                    <b>Order Number: </b>
                                </div>
                                <div class="col-8">
                                    {{ order.order_number }}
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-4">
                                    <b>Order Time: </b>
                                </div>
                                <div class="col-8">
                                    {{ order.transaction_date }}
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-4">
                                    <div class="d-flex align-items-center h-100">
                                        <b>Payment Method: </b>
                                    </div>
                                </div>
                                <div class="col-8">
                                    <select class="form-control" v-model="payment_method">
                                        <option value="">Select Payment Method</option>
                                        <option value="COD">Cash on Delivery</option>
                                        <option value="Cheque">Cheque on Delivery</option>
                                        <option value="PBD">Payment Before Dispatch</option>
                                        <option value="Standard Credit">Standard Credit</option>
                                    </select>
                                    <span v-if="payment_method_error" class="invalid-feedback show" role="alert">
                                        <strong>{{ payment_method_error }}</strong>
                                    </span>
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-4">
                                    <b>Order Status: </b>
                                </div>
                                <div class="col-8">
                                    <span :class="'font-badge badge badge-'+order.status_class">
                                        {{ order.status }}
                                    </span>
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-4">
                                    <b>Route: </b>
                                </div>
                                <div class="col-8">
                                    <span v-if="order.route">{{ order.route.title }}</span>
                                    <span v-else>Not Assigned</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-body">
                            <div class="row mb-2">
                                <div class="col-4">
                                    <b>Customer Name: </b>
                                </div>
                                <div class="col-8">
                                    {{ order.retailer.shop_name }}
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-4">
                                    <b>Customer Code: </b>
                                </div>
                                <div class="col-8">
                                    {{ order.retailer.retailer_id }}
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-4">
                                    <b>User Mobile: </b>
                                </div>
                                <div class="col-8">
                                    {{ order.retailer.phone }}
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-4">
                                    <b>Delivery Address: </b>
                                </div>
                                <div class="col-8">
                                    {{ order.shop_address }}
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-4">
                                    <b>City: </b>
                                </div>
                                <div class="col-8">
                                    {{ order.address.city }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="table-responsive">
                    <table class="table table-bordered" width="100%" cellspacing="0">
                        <thead>
                            <tr>
                                <th>Product Code</th>
                                <th class="w-50">Product Name</th>
                                <th>MRP</th>
                                <th>Quantity</th>
                                <th class="bg-success-50">Accepted Quantity</th>
                                <th>Rate</th>
                                <th>Value</th>
                                <th class="bg-success-50">Accepted Value</th>
                            </tr>
                        </thead>
                        <tbody v-if="items.length > 0">
                            <tr v-for="(item, key) in items" :key="item.id" v-if="order.items[key].quantity_pending > 0" :class="{ 'bg-danger-50': item.quantity_pending > item.product.available_stock }">
                                <td>{{ item.product.tpc }}</td>
                                <td>
                                    {{ item.product.title }}<br>
                                    <span class="fs-nano color-danger-900"><strong>Available Quantities: </strong>{{ item.product.available_stock }}</span><br>
                                    <!-- <span :class="getAvailableStockClass(item, key)"><strong>Available Quantities: </strong>{{ item.product.available_stock }}</span> -->
                                    <span v-if="item.quantity_pending > item.product.available_stock">(Accepted quantity is not available at this moment. Please reduce accepted quantity to less than or equal to available quantities to accept this order.)</span>
                                    
                                </td>
                                <td>
                                    <i class="fal fa-rupee-sign"></i>
                                    {{ item.product.mrp | number_format }}
                                </td>
                                <td>{{ order.items[key].quantity_pending }}</td>
                                <td class="bg-success-50">
                                    <input type="number" 
                                        class="form-control"
                                        min="0"
                                        step="1"
                                        :max="order.items[key].quantity_pending"
                                        v-model.number="item.quantity_pending"
                                        @input="calculateTotals(key)">
                                </td>
                                <td>
                                    <i class="fal fa-rupee-sign"></i>
                                    {{ item.unit_price | number_format }}
                                </td>
                                <td>
                                    <i class="fal fa-rupee-sign"></i>
                                    {{ order.items[key].item_total_pending | number_format }}
                                </td>
                                <td class="bg-success-50">
                                    <i class="fal fa-rupee-sign"></i>
                                    <span class="updated-total">{{ item.item_total_pending | number_format }}</span>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="6" class="text-right">Subtotal</td>
                                <td>
                                    <i class="fal fa-rupee-sign"></i>
                                    {{ order.subtotal | number_format }}
                                </td>
                                <td class="bg-success-50">
                                    <i class="fal fa-rupee-sign"></i>
                                    <span class="updated-subtotal">{{ subtotal | number_format }}</span>
                                </td>
                            </tr>
                            <tr v-if="order.discount > 0">
                                <td colspan="6" class="text-right">
                                    <div class="fw-500">Discount</div>
                                    <ul class="list-unstyled mb-0" v-if="order.transaction_offers.length > 0">
                                        <li v-for="offer in order.transaction_offers" :key="offer.id">
                                            <span class="fs-nano" v-if="offer.type == 'cart'">
                                                Cart Discount
                                            </span>
                                            <span class="fs-nano" v-else>
                                                {{ offer.brand_name }} Brand Discount
                                            </span>
                                        </li>
                                    </ul>
                                </td>
                                <td>
                                    <div class="fw-500">
                                        <i class="fal fa-rupee-sign"></i>
                                        {{ order.discount | number_format }}
                                    </div>
                                    <ul class="list-unstyled mb-0" v-if="order.transaction_offers.length > 0">
                                        <li v-for="offer in order.transaction_offers" :key="offer.id">
                                            <span class="fs-nano" v-if="offer.type == 'cart'">
                                                <i class="fal fa-rupee-sign"></i>
                                                {{ order.cart_discount | number_format }}
                                            </span>
                                            <span class="fs-nano" v-else-if="offer.options_pending.discount_type == 2 && brands[offer.options_pending.brand_id]">
                                                <i class="fal fa-rupee-sign"></i>
                                                {{ offer.options_pending.discount | number_format }}
                                            </span>
                                            <span class="fs-nano" v-else>
                                                N/A
                                            </span>
                                        </li>
                                    </ul>
                                </td>
                                <td class="bg-success-50">
                                    <div class="fw-500">
                                        <i class="fal fa-rupee-sign"></i>
                                        <span class="updated-discount">{{ discount | number_format }}</span>
                                    </div>
                                    <ul class="list-unstyled mb-0" v-if="offers.length > 0">
                                        <li v-for="offer in offers" :key="offer.id">
                                            <span class="fs-nano" v-if="offer.type == 'cart'">
                                                <i class="fal fa-rupee-sign"></i>
                                                {{ cart_discount | number_format }}
                                            </span>
                                            <span class="fs-nano" v-else-if="offer.options_pending.discount_type == 2 && brands[offer.options_pending.brand_id]">
                                                <i class="fal fa-rupee-sign"></i>
                                                {{ offer.options_pending.discount | number_format }}
                                            </span>
                                            <span class="fs-nano" v-else>
                                                N/A
                                            </span>
                                        </li>
                                    </ul>
                                </td>
                            </tr>
                            <tr v-if="order.delivery_charge > 0">
                                <td colspan="6" class="text-right">Delivery Charge</td>
                                <td>
                                    <i class="fal fa-rupee-sign"></i>
                                    {{ order.delivery_charge | number_format }}
                                </td>
                                <td class="bg-success-50">
                                    <i class="fal fa-rupee-sign"></i>
                                    <span class="updated-delivery-charge">{{ delivery_charge | number_format }}</span>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="6" class="text-right">Final Amount</td>
                                <td>
                                    <i class="fal fa-rupee-sign"></i>
                                    {{ order.total | number_format }}
                                </td>
                                <td class="bg-success-50">
                                    <i class="fal fa-rupee-sign"></i>
                                    <span class="updated-total">{{ total | number_format }}</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        computed: {},
        filters: {
            number_format: function (value){
                return parseFloat(value).toLocaleString("en-IN", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                })
            }
        },
        props: {
            order: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                appUrl: document.head.querySelector('meta[name="app-url"]').content,
                items: [],
                offers: [],
                brands: {},
                updatedBrands: {},
                subtotal: 0,
                discount: 0,
                cart_discount: 0,
                delivery_charge: 0,
                total: 0,
                payment_method: "",
                payment_method_error: "",
            };
        },
        mounted() {
            let self = this;
            self.items = JSON.parse(JSON.stringify(self.order.items));
            self.offers = JSON.parse(JSON.stringify(self.order.transaction_offers));
            self.subtotal = self.order.subtotal;
            self.discount = self.order.discount;
            self.cart_discount = self.order.cart_discount;
            self.delivery_charge = self.order.delivery_charge;
            self.total = self.order.total;
            self.setBrands();

            
        },
        methods: {
            setBrands() {
                let self = this;
                self.order.items.forEach(item => {
                    if (item.product.brand_id in self.brands) {
                        self.brands[item.product.brand_id] += item.item_total_pending; 
                    } else {
                        self.brands[item.product.brand_id] = item.item_total_pending; 
                    }
                });
            },
            calculateTotals(key) {
                let self = this;
                let item = self.items[key];
                if (item) {
                    if (!/[\d\.]+/i.test(item.quantity_pending) || item.quantity_pending < 0 || item.quantity_pending > self.order.items[key].quantity_pending) {
                        self.items[key].quantity_pending = self.order.items[key].quantity_pending;
                    }
                    self.items[key].item_total_pending = item.quantity_pending * item.unit_price;
                }
                self.refreshOrder()
            },
            refreshOrder() {
                let self = this;
                let subtotal = 0;
                let percentage = 0;
                let discount = 0;
                let brandPercentage = 0;
                let brandDiscount = 0;
                let cartDiscount = 0;
                if (self.items.length > 0) {
                    self.updatedBrands = {};
                    self.items.forEach(item => {
                        subtotal += item.item_total_pending;
                        if (item.product.brand_id in self.updatedBrands) {
                            self.updatedBrands[item.product.brand_id] += item.item_total_pending; 
                        } else {
                            self.updatedBrands[item.product.brand_id] = item.item_total_pending; 
                        }
                    });
                    self.subtotal = subtotal;
                    percentage = (self.subtotal / self.order.subtotal) * 100;

                    self.order.transaction_offers.forEach((offer, key) => {
                        if (offer.type == 'cart') {
                            cartDiscount = (self.order.cart_discount * percentage) / 100;
                            discount += cartDiscount;
                            self.cart_discount = cartDiscount;
                        }

                        if (offer.type == 'brand') {
                            if (offer.options.discount_type != 3 && self.updatedBrands[offer.options.brand_id] && self.brands[offer.options.brand_id]) {
                                brandPercentage = (self.updatedBrands[offer.options.brand_id] / self.brands[offer.options.brand_id]) * 100;
                                brandDiscount = (offer.options_pending.discount * brandPercentage) / 100;
                                discount += brandDiscount;
                                self.offers[key].options_pending.discount = brandDiscount;
                            }
                        }
                    });
                    self.discount = discount;
                    
                    self.delivery_charge = (self.order.delivery_charge * percentage) / 100;
                    
                    self.total = self.subtotal - self.discount + self.delivery_charge;
                }
            },
            acceptOrder() {
                let self = this;
                var isStockAvailable = true;
                if (self.items.length > 0) {
                    self.items.forEach(item => {
                         if(item.quantity_pending > item.product.available_stock){
                            isStockAvailable = false;
                        }

                    });
                }
                if(!isStockAvailable){
                    alert('Product stocks are not available. Please adjust the product quantities.');
                    return false;
                }
                if (!self.payment_method) {
                    self.payment_method_error = 'Please select payment method.';
                    return false;
                } else {
                    self.payment_method_error = '';
                }
                let message = `You are accepting revised order of Rs.${self.subtotal} out of total order value of Rs.${self.order.subtotal}. Click 'OK' if you have checked the data or click on 'Cancel' if you want to revise further`;
                if (confirm(message)) {
                    let data = {
                        items: self.items,
                        offers: self.offers,
                        subtotal: self.subtotal,
                        discount: self.discount,
                        cart_discount: self.cart_discount,
                        delivery_charge: self.delivery_charge,
                        total: self.total,
                        order_id: self.order.id,
                        payment_method: self.payment_method,
                    };
                    let postUrl = `${self.appUrl}/seller/pending-orders/${self.order.original_order_number}/accept`;
                    axios.post(postUrl, data)
                    .then(function(response) {
                        if (response.data.success) {
                            window.location.href = `${self.appUrl}/seller/pending-orders`;
                        }
                    })
                    .catch(function (response) {
                        alert('Something went wrong, please try again.');
                    });
                }
            },
        }
    };
</script>
